<template>
  <aside class="sidebar-admin">
    <!-- Navigation principale -->
    <nav class="sidebar-nav">
      <ul>
        <li>
          <router-link to="/dashboardAdmin" active-class="active">
            <i class="fas fa-chart-line"></i> Tableau de bord
          </router-link>
        </li>
        <li>
          <router-link to="/adminOrders" active-class="active">
            <i class="fas fa-box"></i> Commandes
          </router-link>
        </li>
        <li>
          <router-link to="/products" active-class="active">
            <i class="fas fa-flask"></i> Produits
          </router-link>
        </li>
        <li>
          <router-link to="/clients" active-class="active">
            <i class="fas fa-user"></i> Clients
          </router-link>
        </li>
        <li>
          <router-link to="/settings" active-class="active">
            <i class="fas fa-cog"></i> Paramètres
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- Bouton déconnexion -->
    <div class="logout-section">
      <button @click="logout">
        <i class="fas fa-sign-out-alt"></i> Déconnexion
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: "SidebarAdmin",
  methods: {
    logout() {
      sessionStorage.clear();
      this.$router.push("/connexion");
    },
  },
};
</script>

<style scoped>
/* --- Structure --- */
.sidebar-admin {
  width: 260px;
  height: 100vh;
  background-color: #05305b;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: sticky;
  top: 0;
  left: 0;
  padding: 25px 0;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

/* --- En-tête --- */
.sidebar-header {
   padding: 12px 25px;
   margin-top: 30px;
}

.sidebar-header h2 {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
}

/* --- Navigation --- */
.sidebar-nav ul {
  list-style: none;
  padding: 0px;
  margin-top: 0px;

}
.sidebar-nav li {
  margin: 6px 0;
}
.sidebar-nav a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 25px;
  color: #dce3ef;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}
.sidebar-nav a:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.sidebar-nav a.active {
  background-color: #00998b;
  border-left: 4px solid #00d1b2;
  color: #fff;
}

/* --- Déconnexion --- */
.logout-section {
  padding: 20px;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.logout-section button {
  background: transparent;
  border: none;
  color: #dce3ef;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
}
.logout-section button:hover {
  color: #00d1b2;
}

/* --- Icônes --- */
i {
  font-size: 17px;
}

/* --- Mode sombre --- */
@media (prefers-color-scheme: dark) {
  .sidebar-admin {
    background-color: #0f1720;
    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.6);
  }
  .sidebar-nav a {
    color: #cfd8dc;
  }
  .sidebar-nav a.active {
    background-color: #00bfa5;
  }
  .logout-section {
    border-top: 1px solid #333;
  }
}

/* --- Responsive --- */
@media (max-width: 900px) {
  .sidebar-admin {
    width: 220px;
  }
  .sidebar-header h2 {
    font-size: 16px;
  }
  .sidebar-nav a {
    font-size: 14px;
    padding: 10px 18px;
  }
}

@media (max-width: 600px) {
  .sidebar-admin {
    position: fixed;
    width: 100%;
    height: auto;
    bottom: 0;
    top: auto;
    flex-direction: row;
    justify-content: space-around;
    padding: 10px 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.25);
  }

  .sidebar-header {
    display: none;
  }
.logout-section {
    display: block;
    border-top: none;
    border-left: 1px solid rgba(255, 255, 255, 0.15);
    padding: 5px 0;
  }

  .logout-section button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #fff;
  }

  .logout-section i {
    font-size: 18px;
    margin-bottom: 3px;
  }

  .sidebar-admin {
    position: fixed;
    width: 100%;
    height: auto;
    bottom: 0;
    top: auto;
    flex-direction: row;
    justify-content: space-around;
    padding: 8px 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.25);
  }

  .sidebar-nav ul {
    display: flex;
    justify-content: space-around;
    width: 85%;
  }

  .sidebar-nav a {
    flex-direction: column;
    gap: 4px;
    padding: 6px;
    font-size: 12px;
  }

  i {
    font-size: 18px;
  }
}
</style>
